import React, { useRef, useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import "../../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const CreateABMCompany = ({ OpenForm, setTypeDocument, typeDocument }) => {
  const downloadLinkRef = useRef(null);
  const [tipeButtonAMB] = useState({
    viewList: true,
    tipeForm: "Crear",
  });

  const handleClick = (e) => {
    e.preventDefault();
    handlerdowload(e);
    handleCreateClick(e);
  };

  const handlerdowload = async (e) => {
    e.preventDefault();
    OpenForm(tipeButtonAMB);
  };

  const handleCreateClick = (e) => {
    e.preventDefault();
    setTypeDocument(typeDocument);
  };
  return (
    <button
      className="button_abm"
      type="button"
      onClick={(e) => handleClick(e)}
      ref={downloadLinkRef}
    >
      <i className="fa fa-refresh"></i>
      <AiFillFileAdd className="icon-list" />
    </button>
  );
};

export default CreateABMCompany;